export const payment = [
    {
        id: 1, 
        paymentID: 'direct-bank-transfer',
        value: 'DIRECT',
        title: 'direct bank transfer',
        content: 'Make your payment directly into our bank account. Please use your Order ID as the payment reference. Your order won’t be shipped until the funds have our account.'
    },
    {
        id: 2,
        paymentID: 'cash-on-delivery',
        value: 'CASH',
        title: 'cash on delivery',
        content: 'Please send your cheque to Store Name, Store Street, Store Town, Store State / County, Store Postcode.'
    },
    {
        id: 3,
        paymentID: 'paypal',
        value: 'PAYPAL',
        title: 'paypal',
        content: 'Pay via PayPal; you can pay with your credit card if you don’t have a PayPal account.'
    },
];